import { CallHistoryList } from "@constructorfleet/ui/design-system";
import { RefreshIcon } from "@constructorfleet/ui";
import { useCallback } from "react";
import type { UaProductDbClient } from "../pages";
import { loadUaCallHistory } from "../ua-call-settings";

export function CallHistoryPanel({ dbClient }: { dbClient: UaProductDbClient }) {
  const requestAdmin = dbClient.requestAdmin;

  const loadCalls = useCallback(async () => {
    if (!requestAdmin) return { ok: false as const, error: "Not authorized" };
    return loadUaCallHistory(requestAdmin);
  }, [requestAdmin]);

  return (
    <CallHistoryList
      loadCalls={loadCalls}
      idPrefix="ua-call-history"
      refreshIcon={<RefreshIcon />}
    />
  );
}
